<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17PlRqq/tc-custom/9781466806603.jpg?1731838271254" alt="This image is the cover for the book Body in the Bouillon, The Faith Fairchild Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Body in the Bouillon, The Faith Fairchild Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A minister’s wife is determined to find out who’s preying on the residents of a New England retirement home in this acclaimed cozy mystery series.</b><br/><br/>Minister’s wife, sometime sleuth, and culinary artist Faith Sibley Fairchild is intrigued by rumors of mysterious doings at Hubbard House—an elegant, secluded retirement home for the well-heeled Yankees of Aleford, Massachusetts. Determined to do some surreptitious snooping, she joins the pricey retreat’s flu-depleted kitchen staff, only to witness an aging resident collapse face-first into a bowl of Faith’s hot and savory bouillon.<br/><br/>Faith barely has time to ponder the suspicious death before a blackmailing drug dealer turns up dead in her bedroom! Now one thing is clear to the amateur investigator: murder doesn’t just happen at Hubbard—it’s the house specialty. And Faith’s own demise might very well be the next item on the menu.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katherine Hall Page
      </h2>
      
      <p class="authorDescription body article">Katherine Hall Page’s first mystery, <I>The Body in the Belfry</I>, won an Agatha Award for Best First Mystery Novel. The fifteenth in the series, <I>The Body in the Snowdrift</I>, won the Agatha Award for Best Mystery Novel. Page was also awarded the Agatha for Best Short Story for "The Would-Be Widower" in the Malice Domestic X collection. She was an Edgar nominee for her juvenile mystery, <I>Christie & Company Down East</I>. <I>The Body in the Lighthouse</I> was one of three nominees for The Mary Higgins Clark Award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69c1d748